/* ドロップダウン */
import React from 'react';
import { Dropdown } from 'react-bootstrap';
var DropdownMenu = function (_a) {
    var label = _a.label, sources = _a.sources;
    return (React.createElement(Dropdown, null,
        React.createElement(Dropdown.Toggle, { variant: "main-color", id: "dropdown-basic" }, label),
        React.createElement(Dropdown.Menu, null, sources.map(function (source, index) {
            return (React.createElement(Dropdown.Item, { key: index, href: "" + location.origin + process.env.MIX_MOCK_URL + "/" + source.key }, source.value));
        }))));
};
export default DropdownMenu;
